module.exports = __webpack_public_path__ + "img/tips.c90b0fb3.svg";